
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

@Component({
  selector: 'icon-book',
  imports: [],
  templateUrl: './book-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookIconComponent extends BaseIconComponent {}
